const sleep = millis => new Promise(resolve => setTimeout(resolve, millis));

export default {
  namespaced: true,
  state: {
    // キャンセルフラグ
    isCancel: false,
    // 進捗率
    progressPercent: 0,
  },
  getters: {
    // キャンセルフラグ
    isCancel: state => state.isCancel,
    // 進捗率
    progressPercent: state => state.progressPercent,
  },
  mutations: {
    setCancel(state, isCancel){
      state.isCancel = isCancel
    },
    setProgressPercent(state, progressPercent){
      state.progressPercent = progressPercent
    },
  },
  actions: {
    cancel({ commit }){ 
      commit('setCancel', true)
    },
    async createZipFile(context, args){
      context.commit('setCancel', false);
      context.commit('setProgressPercent', 0);
      const firstArgs = {
        ...args,
        __apiOptions: { noDisplayLoading: true },
      }
      const firstResult = await context.dispatch('api/startBulkDownloadPhoto', firstArgs, { root: true })
      if(!firstResult){
        return;
      }
      let pollingMillisec = firstResult.polling_millisec
      let jobCode = firstResult.job_code
      let result = null;
      for(;;){
        // キャンセルされた場合
        if(context.getters.isCancel) return

        // 完了
        if(!pollingMillisec || !jobCode){
          context.commit('setProgressPercent', 100);
          return result
        }
        await sleep(pollingMillisec);
        const loopArgs = {
          polling_millisec: pollingMillisec,
          job_code: jobCode,
          __apiOptions: { noDisplayLoading: true },
        }
        result = await context.dispatch('api/checkBulkDownloadPhoto', loopArgs, { root: true })
        if(!result){
          return;
        }
        context.commit('setProgressPercent', result.progress_percent);
        pollingMillisec = result.polling_millisec
        jobCode = result.job_code
      }
    },
  },
}
